import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "state"
}
const _hoisted_3 = {
  key: 1,
  class: "state"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "item-top" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = { class: "muted" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "light" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("My Lead Meetings", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.load
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(_component_ion_spinner, { name: "crescent" })
                ]))
              : (!_ctx.meetings.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "No upcoming meetings. Schedule one from a lead."))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groups, (group) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: group.title
              }, [
                (group.items.length)
                  ? (_openBlock(), _createElementBlock("h4", {
                      key: 0,
                      class: _normalizeClass(["sub-h", group.cls])
                    }, _toDisplayString(group.title) + " (" + _toDisplayString(group.items.length) + ")", 3))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: m.id,
                    class: _normalizeClass(["item", group.cls]),
                    onClick: ($event: any) => (_ctx.$router.push('/sales-lead-meeting/' + m.id))
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("b", null, _toDisplayString(m.lead ? m.lead.company_name : ''), 1),
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.time(m.scheduled_at)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(m.meeting_type) + " · " + _toDisplayString(m.mode), 1),
                      (m.location)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, " · " + _toDisplayString(m.location), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(m.lead ? m.lead.contact_name + ' · ' + m.lead.contact_phone : ''), 1)
                  ], 10, _hoisted_4))
                }), 128))
              ], 64))
            }), 128))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}